import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  Config, getAssetTypes,
  getConfig, getDealTypes,
  getLookups, getSelectedBusinessUnit, getSelectedDeal, getSelectedDealId,
  initialConfigState,
  initialLookupsState,
  Lookups,
  toggleLoading
} from "../../../redux";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {DealService} from "../../services";
import {IBusinessUnit} from "../../../business-units/models";
import {AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {MatChipInputEvent} from "@angular/material/chips";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {Observable, of, startWith, Subscription} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {ILookup} from "../../../../models";
import {IDealRequest} from "../../models";
import {HttpErrorResponse} from "@angular/common/http";
import {map} from "rxjs/operators";
import {UtilService} from "../../../shared/services";
import {IDealCard} from "../../../shared/models";
import { LookupService } from 'src/app/services';

@Component({
  selector: 'app-deal-metrics',
  templateUrl: './deal-metrics.component.html',
  styleUrls: ['./deal-metrics.component.scss']
})
export class DealMetricsComponent implements OnInit {

  userForm = new FormGroup({
    id: new FormControl(),
    issuerEntityName: new FormControl(''),
    countryId: new FormControl(''),
    stateorProvinceId: new FormControl('', []),
    city: new FormControl('', []),

    issuerDeals: new FormArray<FormControl>([], atLeastOneCheckboxCheckedValidator()),
    issuerDealAssets: new FormArray<FormControl>([], atLeastOneCheckboxCheckedValidator()),
    issuerDealAreasOfFocus: new FormArray<FormControl>([]),
    
    fundraiseSize: new FormControl(0),
    timeLineTypeId: new FormControl(),
    rondeivuFundraiseSize: new FormControl(0),
    firstCloseOccured: new FormControl(),
    anchorSeeking: new FormControl(),
    
    targetMoicBear: new FormControl(),
    minimumDuration: new FormControl(),
    targetMoicBase: new FormControl(),
    expectedDuration: new FormControl(),
    targetMoicBest: new FormControl(),
    maximumDuration: new FormControl(),
    
    notes: new FormControl(),
  });

  //theme input
  @ViewChild('themeInput') themeInput: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  themeCtrl = new FormControl('');
  selectedThemes: string[] = [];

  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute,
    public lookupService: LookupService,
    private toastr: ToastrService,
    private dealService: DealService,
    public util: UtilService
  ) {
    
  }

  ngOnInit() {
    // var dealId = this.activatedRoute.snapshot.parent?.paramMap.get("id") || "";
    // console.log("deal id", dealId);

    this.dealService.getDealMetrics().subscribe({
      next: (deal: IDealRequest) => {
        // set the selected assets
        this.patchValues(deal);
       
      }, error: error => {
        this.toastr.error("Unable to get deal metrics!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }


  patchValues(deal: IDealRequest) {
    this.userForm.patchValue(deal);

     // deal types
    this.lookupService.lookups.dealTypes.forEach(x => {
      var isChecked = deal.issuerDeals.map(x => x.key).includes(x.key);
      this.dealTypes.push(new FormControl(isChecked));
    })

    // asset classes
    this.lookupService.lookups.assetTypes.forEach(x => {
      var isChecked : boolean = deal.issuerDealAssets.map(x => x.key).includes(x.key);
      this.assetClasses.push(new FormControl(isChecked));
    })

    // themes / keywords
    this.selectedThemes = deal.issuerDealAreasOfFocus.map(x => x.key);
  }
  
  get dealTypes(): FormArray { return this.userForm.get("issuerDeals") as FormArray; }
  get assetClasses(): FormArray { return this.userForm.get("issuerDealAssets") as FormArray; }
  get anchorInterestTypes(): FormArray { return this.userForm.get("issuerDealAreasOfFocus") as FormArray; }

  // themes / keywords
  addWord(event: any) {
    var optionValue = event.value;
    if (this.selectedThemes.includes(optionValue) == false) {
      // get the value of the key 
      if (this.selectedThemes.includes(optionValue) == false) {
        this.selectedThemes.push(optionValue);
      }
      event.chipInput!.clear();
    }
  }

  removeWord(word: string) {
    this.selectedThemes = this.selectedThemes.filter(x => x != word);
  }

  selectedTheme(event: MatAutocompleteSelectedEvent) {
    var optionValue = event.option.value;
    var values = this.lookupService.lookups.areasOfFocus.filter(x => x.key == optionValue);
    if (values.length > 0) {
      if (this.selectedThemes.includes(values[0].value) == false) {
        this.selectedThemes.push(values[0].value);
      }
    }
  }


  save () {
    var issuerDeals : ILookup[] = [];
    var issuerDealAssets : ILookup[] = [];

    let payload = this.userForm.getRawValue() as unknown as IDealRequest;
    this.userForm.value.issuerDeals?.forEach((x, i) => {
      if (x === true) {
        issuerDeals.push(<ILookup>{ key : this.lookupService.lookups.dealTypes[i].key });
      }
    });

    this.userForm.value.issuerDealAssets?.forEach((x, i) => {
      if (x === true) {
        issuerDealAssets.push(<ILookup>{ key : this.lookupService.lookups.assetTypes[i].key });
      }
    });

    // areas of focus
    payload.issuerDealAreasOfFocus = this.selectedThemes.map(x =><ILookup> { key: x });


    payload.issuerDeals = issuerDeals;
    payload.issuerDealAssets = issuerDealAssets;
    payload.notes = this.userForm.get('notes')?.value.toString() || ''

    // console.log("deal payload", payload);

    this.store.dispatch(toggleLoading({loading: true}));
    this.dealService.updateDealMetrics(payload).subscribe((ds: any) => {
      this.store.dispatch(toggleLoading({loading: false}));
      this.toastr.success("Deal Metrics Updated!", $localize`:@@companyName:Rondeivu`);
    }, (error: HttpErrorResponse) => {
      this.store.dispatch(toggleLoading({loading: false}));
      this.toastr.error("Unable to update deal metrics!", $localize`:@@companyName:Rondeivu`);
    });

  }
}

export function atLeastOneCheckboxCheckedValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    if (!formArray || !formArray.value || !Array.isArray(formArray.value)) {
      return null;
    }

    const totalChecked = formArray.value.filter((v: boolean) => v === true).length;
    return totalChecked >= 1 ? null : { minChecked: true };
  }
}